import {
  Icon,
  InputText,
  Select,
  TextArea,
} from '@fattureincloud/fic-design-system'
import styled from 'styled-components'

import FICColors from '../common/FICColors'
import { Realm } from '../redux/features/realm/realmSlice'
import { ButtonType, Size } from './common.types'

const defaultColor = FICColors.button.primary.blue

export const LeftWrapper = styled.span<{ hasText: boolean }>`
  margin-right: ${({ hasText }) => (hasText ? 4 : 0)}px;
`

export const RightWrapper = styled.span<{ hasText: boolean }>`
  margin-left: ${({ hasText }) => (hasText ? 4 : 0)}px;
`

export const CustomIcon = styled(Icon)<{ type: ButtonType }>`
  ${(props) =>
    props.type == 'action' &&
    `
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 100%;
      text-decoration: none;
      cursor: pointer;
      font-size: 22px;
      color: ${FICColors.actionButton.normal};
      &:hover {
                color: ${FICColors.actionButton.hover};
              }
      a:focus, a:hover {
                text-decoration: none;
              }
      `}
  ${(props) =>
    props.type == 'text' &&
    `
        display: inline;
      `}
`

export const ArticleReadOnlyContainer = styled.div`
    a:hover,
    a:focus {
        cursor: pointer;
        text-decoration: underline !important;
    }
`



export const LinkContainer = styled.div<{ isDisabled: boolean }>`
  display: inline-block;
  padding: 20px 0;
  @media (max-width: 425px) {
    padding: 17px 0;
  }
  cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
  a {
    color: ${FICColors.defaultBlue};
    line-height: 24px;
    text-decoration: underline;
    cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
  }
`

export const Link = styled.a<{
  isDisabled?: boolean
  isLoading?: boolean
  size?: Size
  text: string | undefined
}>`
  ${(props) =>
    props.type == 'facebook' &&
    `
          color: ${
            props.isDisabled ? FICColors.link.gray : FICColors.link.normal
          };
          cursor: pointer;
          text-decoration: none;
          &:hover {
            color: ${
              props.isDisabled ? FICColors.link.gray : FICColors.link.hover
            };
            text-decoration: ${props.isDisabled ? 'none' : 'underline'};
            cursor: ${props.isDisabled ? 'default' : 'pointer'};
          }
    `}

  .fic-simple-button {
    display: inline-block;
    background-color: ${defaultColor.normal};
    color: ${defaultColor.text};
    border: 1px solid rgba(51, 51, 51, 0.16);
    border-radius: 4px;
    box-shadow: 0 1px 2px 0 rgba(51, 51, 51, 0.08);
    min-width: 105px;
    width: auto;
    height: 32px;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    padding: 4px 30px;
    box-sizing: border-box;
    cursor: pointer;
    text-decoration: none !important;
    ${(props) =>
      !props.isLoading &&
      `
              ${
                !props.isDisabled &&
                `&:hover {
                    background-color: ${defaultColor.hover};
                    color: ${FICColors.white};
                  }
                `
              }
                &:active {
                    background-color: ${defaultColor.active};
                  }
                &:focus {
                    text-decoration: none;
                  }
            `}
    ${(props) =>
      props.size === 'small' &&
      `
                  min-width: 91px;
                `}
          ${(props) =>
      props.size === 'large' &&
      `
                  min-width: 111px;
                  height: 40px;
                  line-height: 30px;
                `}
          ${(props) =>
      props.text === undefined &&
      `
                  min-width: unset;
                  line-height: unset;
                  height: auto;
                `}
    .a {
      color: rgb(0, 148, 212);
      line-height: 24px;
      text-decoration: underline;
    }
  }
`

export const FicButton = styled.a<{
  isFeedback: boolean
  isDisabled?: boolean
  isLoading?: boolean
  size?: Size
  text: string | undefined
}>`
  display: inline-block;
  margin: 0;
  vertical-align: middle;
  text-shadow: none;
  box-shadow: 0px 1px 2px rgb(51 51 51 / 8%);
  background-image: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 7px 14px;
  -webkit-transition: all 0.1s linear;
  -moz-transition: all 0.1s linear;
  transition: all 0.1s linear;
  height: 40px !important;
  @media all and (-ms-high-contrast: none) {
    min-height: 40px;
  }
  max-height: unset !important;
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  text-transform: none;
  background-color: rgb(2, 148, 211);
  border: 2px solid #0294d3;
  width: auto;
  color: ${FICColors.white};
  line-height: 24px;
  text-decoration: none;

  @media all and (-ms-high-contrast: none) {
    & {
      padding: 5px 14px 14px !important;
    }
  }
  &:first-child {
    margin-right: 24px;
    color: ${FICColors.white};
  }
  &:nth-child(2) {
    background-color: #fff;
    color: #0294d3;
    &:hover {
      background-color: #0294d3;
      color: ${FICColors.white};
    }
  }
  &:hover {
    background-color: ${FICColors.white};
    color: #0294d3;
    opacity: 1;
  }
  &.btn-disabled {
    opacity: 0.6;
    pointer-events: none;
  }
  &.yes {
    letter-spacing: -0.5px;
    width: 160px;
    background-color: ${FICColors.white};
    color: #0294d3;
    margin-right: 12px;
    @media (max-width: 425px) {
      width: 152px;
      margin-right: 16px;
    }
    @media (max-width: 350px) {
      margin-right: 0;
      margin-bottom: 16px;
    }
    &:hover {
      background-color: #0294d3;
      color: ${FICColors.white};
      .svg-inline--fa {
        color: ${FICColors.white};
      }
    }
  }
  &.no {
    letter-spacing: -0.5px;
    width: 160px;
    color: ${FICColors.white};
    background-color: #0294d3;
    border-color: #0294d3;
    margin-left: 12px;
    @media (max-width: 425px) {
      width: 152px;
      margin-left: 0;
    }
    &:hover {
      background-color: ${FICColors.white};
      color: #0294d3;
    }
  }

  &.assistance {
    line-height: 15px;
    max-height: 48px !important;
    height: 48px !important;
    padding: 15px !important;
    background-color: ${FICColors.white};
    color: #0294d3;

    @media (max-width: 425px) {
      margin-right: 16px;
    }
    @media (max-width: 350px) {
      margin-right: 0;
      margin-bottom: 16px;
    }
    &:hover {
      background-color: #0294d3;
      color: ${FICColors.white};
      .svg-inline--fa {
        color: ${FICColors.white};
      }
    }
  }
  &.access {
    height: 40px;
    border: 2px solid rgb(255, 255, 255);
    max-height: unset;

    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    text-transform: none;
    background-color: transparent;
    color: ${FICColors.white};
    &:hover {
      color: ${FICColors.white};
      background-color: rgba(255, 255, 255, 0.24);
    }
  }
  &.goback {
    height: auto !important;
    max-height: unset !important;
    text-transform: none;
    width: auto;
    border-radius: 18.5px !important;
    color: #fff;
    font-size: 18px !important;
    font-weight: 400;
    line-height: 24px;
    background-color: rgba(255, 255, 255, 0.24);
    border: none;
    &:hover {
      background: #0a79a8;
    }
  }
`

export const Input = styled(InputText)`
  .label,
  .input__label {
    font-weight: normal;
    text-align: left;
    padding: initial;
  }
`
export const InputFlex = styled(Input)`
  flex: 1;
`

export const InputArea = styled(TextArea)`
  .label,
  .input__label {
    font-weight: normal;
    text-align: left;
    padding: initial;
  }
  .input__text.input__text__textarea {
    resize: vertical;
  }
  margin-bottom: 10px;
`

export interface SelectProps {
  controlHeight?: number
  menuHeight?: number
  width?: number
}

export interface SelectOption {
  id: number
  label: string
  value: Realm
}

export const Selection = styled(Select)<SelectProps>`
  flex: 1;
  height: ${(props) => (props.controlHeight ? props.controlHeight : '32')}px;
  ${(props) =>
    props.width &&
    `
      width: ${props.width}px;
    `}
  .label,
  .input__label {
    font-weight: normal;
    text-align: left;
    padding: initial;
  }
  .css-1b5lcpe-control,
  .css-1t97i8z-ValueContainer,
  .css-lw5t2n-ValueContainer,
  .css-1b5lcpe-control,
  .css-1tl9qrb-control,
  .sc-eerKOB .bKwnMd .css-11kg927-container {
    height: ${(props) => (props.controlHeight ? props.controlHeight : '32')}px;
    max-height: ${(props) =>
      props.controlHeight ? props.controlHeight : '32'}px;
    z-index: 11000;
    align-items: baseline;
  }
  .css-1okebmr-indicatorSeparator {
    height: ${(props) =>
      props.controlHeight ? props.controlHeight - 16 : '16'}px;
    max-height: ${(props) =>
      props.controlHeight ? props.controlHeight - 16 : '16'}px;
    z-index: 11000;
  }
  .css-1e1vw9j-menu,
  .css-11unzgr,
  .css-26l3qy-menu,
  .sc-hTZgZg,
  .css-4ljt47-MenuList {
    max-height: ${(props) => (props.menuHeight ? props.menuHeight : '150')}px;
    z-index: 11001;
  }
`
